import { render, staticRenderFns } from "./Goto.vue?vue&type=template&id=06194141&scoped=true&"
import script from "./Goto.vue?vue&type=script&lang=js&"
export * from "./Goto.vue?vue&type=script&lang=js&"
import style0 from "./Goto.vue?vue&type=style&index=0&id=06194141&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06194141",
  null
  
)

export default component.exports